module.exports = __webpack_public_path__ + "static/img/img_logo_5.c26c80c2.png";